<template>
  <header class="header">
    <div class="header_left">
      <span>{{companyName}}</span>
      <el-dropdown trigger="click"  @command="dropCommand">
        <span class="el-dropdown-link">
          {{'(' + rootLevel +')'}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
           <el-dropdown-item
              v-for="item in placeList"
              :key="item.id"
              :command="{id:item.id,name:item.name}"
            > {{ item.name }}
          </el-dropdown-item>
          <!--<el-dropdown-item command="mainLevel">工人文化宫</el-dropdown-item>
          <el-dropdown-item command="nextLevel">下级别水表</el-dropdown-item>-->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="header_center">
      <span>公共机构节水监测系统</span>
    </div>
    <ul class="header_right">
      <li @click="logout">返回</li>
      <li @click="rgimeFlg=true">制度</li>
    </ul>
    <rgimeDialog 
      :rgimeFlg="rgimeFlg"
      @rgime-dialogFlg="rgimeDialogFlg"/>    
  </header>

</template>

<script>
import rgimeDialog from './regimeDialog'
export default {
  components: {
    rgimeDialog,
  },
  data() {
    return {
      rootLevel: '工人文化宫',
      rgimeFlg: false,
      companyName:'',
      placeList:[],
      placeid:0
    }
  },
  watch: {

  },
  created(){
    var issys = sessionStorage.getItem("issys");
    sessionStorage.setItem('selectPlace',0);
    if(issys == 1){
      this.companyName = '节水监测云平台';
    }else{
      this.companyName = sessionStorage.getItem("companyName");
    }
    this.getList();
  },
  mounted() {

  },
  methods: {
    logout() {
      var type = parseInt(sessionStorage.getItem("usertype"));
      if(type != 1){
        sessionStorage.clear();
      }
      this.$router.push('/home')
    },
    getList() {
      var that = this;
      this.$post("/apis/manage/place/getPlaceList", {
        token: sessionStorage.getItem("token"),
      })
        .then(function(res) {
          if (res.errno == 0) {
            var data = res.data;
            var newList = [];
            for (var i = 0; i < data.length; i++) {
              if(i==0){
                that.rootLevel = data[i].name;
                that.placeid = data[i].id;
                sessionStorage.setItem('selectPlace',data[i].id);
                sessionStorage.setItem('selectPlaceName',data[i].name);
                that.$emit('fatherMethod');
              }
              newList.push({
                id: data[i].id,
                name: data[i].name,
              });
            }
            that.placeList = newList;
          }
        })
        .catch(function(err) {
          window.console.log(err);
        });
    },
    dropCommand(command) {
      this.rootLevel = command.name;
      this.placeid = command.id;
      sessionStorage.setItem('selectPlace',command.id);
      sessionStorage.setItem('selectPlaceName',command.name);
      console.log(23333333);
      //this.fatherMethod();
      this.$emit('fatherMethod');
      //command == 'mainLevel' ? this.rootLevel = '工人文化宫' : this.rootLevel = '下级别水表'
    },
    rgimeDialogFlg(val) {
      this.rgimeFlg = val
    },
    selectPlace(val) {
      this.rgimeFlg = val
    }
  }
}
</script>

<style lang="less" scoped>
  .header {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 99;
    .header_left {
      width: 260px;
      height: 40px;
      position: absolute;
      top: 20%;
      left: 4%;
      >span {
        padding-right: 6px;
      }
    }
    .header_center {
      width: 46%;
      line-height: 60px;
      margin: 0 auto;
      text-align: center;
      >span {
        line-height: 60px;
        font-size: 26px;
        font-weight: 700;
        letter-spacing: 2px;
        mask-image: linear-gradient(rgba(52, 54, 136, 1), transparent)    
      }
    }
    .header_right {
      width: 200px;
      height: 40px;
      position: absolute;
      top: 20%;
      right: 4%;    
      >li {
        cursor: pointer;
        float: right;
        &:last-child {
          padding-right: 28px;
        }
      }
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #dedede;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }


  }
</style>